import { useNavigate } from 'react-router-dom'

function QuickActions() {
  const navigate = useNavigate()

  const actions = [
    {
      title: 'Nouvel article',
      icon: '📝',
      description: 'Créer une actualité',
      color: 'blue',
      path: '/admin/news',
    },
    {
      title: 'Ajouter un document',
      icon: '📄',
      description: 'Téléverser un fichier',
      color: 'green',
      path: '/admin/documents',
    },
    {
      title: 'Gérer les menus',
      icon: '🔗',
      description: 'Modifier la navigation',
      color: 'purple',
      path: '/admin/menus',
    },
    {
      title: 'Voir les messages',
      icon: '✉️',
      description: 'Messages de contact',
      color: 'orange',
      path: '/admin/messages',
    },
  ]

  return (
    <div className="quick-actions">
      <h2 className="section-title">Actions rapides</h2>
      <div className="actions-grid">
        {actions.map((action) => (
          <button
            key={action.title}
            className={`action-button action-${action.color}`}
            onClick={() => navigate(action.path)}
          >
            <div className="action-icon">{action.icon}</div>
            <div className="action-content">
              <div className="action-title">{action.title}</div>
              <div className="action-description">{action.description}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default QuickActions
